import { ICategory, IChildCategory } from '@/app/[locale]/_types';
import { HStack } from '@chakra-ui/react';
import React from 'react';
import CategoryCarousel from './CategoryCarousel';
export interface IExtendedCategory extends IChildCategory {
  is_child?: boolean;
}

const CategoryCard = ({
  categories,
}: {
  categories: (ICategory | IExtendedCategory)[];
}) => {
  return (
    <HStack flexWrap={'wrap'}>
      <CategoryCarousel categories={categories} />
    </HStack>
  );
};

export default CategoryCard;
